import { Injectable } from "@angular/core";
import { CoreHttpClient } from "@obg/ngx.core";
import { Observable } from "rxjs";

import { RegistrationConfigService } from "../registration.config";

@Injectable({
	providedIn: "root",
})
export class AddressService {
	constructor(
		private httpClient: CoreHttpClient,
		private registrationConfig: RegistrationConfigService
	) {}

	/* countryCode to be changed dynamically to make service reusable */
	getAddresses(): Observable<any> {
		return this.httpClient.get<any>({
			url: this.registrationConfig.getAddressesEndpoint(),
			searchParams: {
				countryCode: "CO",
				useCache: true,
			},
		});
	}
}
